import {GenericService, ResultType} from '@/shared/xhttp';
import {BoisType, Client} from '@/models';

export class ClientService extends GenericService<Client> {
}